export enum DeclinationEmailResults {
  Sent = 'sent',
  Canceled = 'canceled',
  DeclineWithoutEmail = 'declineNoEmail',
}
